function actorReducer(prevState, action) {
    switch (action.type) {
        case 'INITIALIZE_ACTORS': {
            const { payload } = action;
            return payload.reduce((actorsById, actor) => {
                actorsById[actor.actorId] = {
                    actorId: actor.actorId,
                    name: actor.name || actor.role,
                    image: actor.image,
                    hideText: false,
                    mute: false,
                };
                return actorsById;
            }, {});
        }
        case 'TOGGLE_TEXT_ACTOR': {
            const { payload: actorId } = action;
            const actor = prevState[actorId];
            if (!actor)
                return prevState;
            return { ...prevState, [actorId]: { ...actor, hideText: !actor.hideText } };
        }
        case 'TOGGLE_MUTE_ACTOR': {
            const { payload: actorId } = action;
            const actor = prevState[actorId];
            if (!actor)
                return prevState;
            return { ...prevState, [actorId]: { ...actor, mute: !actor.mute } };
        }
        default:
            throw new Error('unknown actorAction');
    }
}

export { actorReducer };
